export const setUserInfo = (userData) => ({
	type: 'SET_USER_INFO',
	payload: userData,
});
